module.exports = "/lucky-balls/video/intro_ru.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/video/intro_ru.mp4
// module id = 891
// module chunks = 0